export default class InputChangeHandler {

    constructor(nameOfStateProperty, component) {
        this.nameOfStateProperty = nameOfStateProperty;
        this.component = component;
    }

    onChange = (event) => {
        const target = event.target;

        const value = target.value;
        const name = target.id;

        // Label speichert den Anzeigetext für Auswahleinträge, um diese beim späteren Anzeigen nicht erneut aus dem Value auflösen zu müssen
        const label = target.options ? target.options[target.selectedIndex].innerHTML : undefined;

        this.component.setState(prevState => {
            const newFormData = { ...prevState[this.nameOfStateProperty] };

            newFormData[name].value = value;
            if (label) {
                newFormData[name].label = label;
            }

            return {
                [this.nameOfStateProperty]: newFormData
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/InputChangeHandler.js